import React from "react";
import { CheckCircle2, CircleDot, XCircle, Clock, SkipForward } from "lucide-react";

const statusLabel = (status) => {
  switch (status) {
    case "approved":
      return "Đã duyệt";
    case "rejected":
      return "Từ chối";
    case "pending":
      return "Đang chờ bạn duyệt";
    case "waiting":
      return "Chờ đến lượt";
    case "skipped":
      return "Bỏ qua (đã duyệt ở cấp)";
    case "cancelled":
      return "Đã hủy";
    default:
      return status;
  }
};

const ApprovalTimeline = ({ steps = [] }) => {
  return (
    <div className="space-y-0">
      {steps.map((step, index) => {
        const isApproved = step.status === "approved";
        const isRejected = step.status === "rejected";
        const isSkipped = step.status === "skipped";
        const isPending = step.status === "pending";
        const isWaiting = step.status === "waiting";

        return (
          <div key={index} className="flex gap-4 items-stretch">
            <div className="flex flex-col items-center">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 border-2 ${
                  isApproved
                    ? "bg-emerald-50 border-emerald-500 text-emerald-600"
                    : isRejected
                    ? "bg-red-50 border-red-500 text-red-600"
                    : isSkipped
                    ? "bg-slate-100 border-slate-300 text-slate-500"
                    : isPending
                    ? "bg-amber-50 border-amber-500 text-amber-600 animate-pulse"
                    : "bg-gray-50 border-gray-200 text-gray-400"
                }`}
              >
                {isApproved ? (
                  <CheckCircle2 size={16} />
                ) : isRejected ? (
                  <XCircle size={16} />
                ) : isSkipped ? (
                  <SkipForward size={14} />
                ) : isPending ? (
                  <Clock size={16} />
                ) : (
                  <CircleDot size={16} />
                )}
              </div>
              {index < steps.length - 1 && (
                <div className="w-0.5 flex-1 min-h-[12px] bg-gray-100 my-1" />
              )}
            </div>

            <div className="flex-1 pb-6">
              <div className="flex flex-wrap items-center gap-2 mt-0.5">
                <span className="text-[10px] font-black uppercase tracking-widest text-red-700 bg-red-50 px-2 py-0.5 rounded-md">
                  {step.role_name || `Cấp ${step.level}`}
                </span>
                <span className="text-sm font-bold text-gray-800">
                  {step.approver_name}
                </span>
              </div>

              <div className="text-xs text-gray-500 mt-1 font-medium">
                {statusLabel(step.status)}
              </div>

              {(step.action_at || step.approved_at) && (
                <div className="text-[10px] text-gray-400 mt-2">
                  {new Date(step.action_at || step.approved_at).toLocaleString(
                    "vi-VN"
                  )}
                </div>
              )}

              {step.reject_reason && (
                <div className="text-xs text-red-600 mt-2 bg-red-50/80 rounded-lg px-3 py-2 border border-red-100">
                  Lý do: {step.reject_reason}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ApprovalTimeline;
